<template>
  <header
    class="header-height fixed left-0 top-0 z-header flex w-full items-center bg-white"
    :class="headerClass"
  >
    <div class="w-full px-3 tablet:px-4 desktop:px-6">
      <div
        class="flex w-full items-center justify-between desktop:justify-start"
      >
        <LayoutHeaderLogo />

        <LayoutHeaderMenu v-show="isDesktop" class="mr-4" />

        <!-- ** Desktop ** -->
        <div v-if="isDesktop" class="flex items-center gap-2">
          <!-- Search Button -->
          <LayoutHeaderSearchButton />
          <!-- Contact Us Button -->
          <LayoutHeaderContactUsButton />
          <!-- Console Button -->
          <LayoutHeaderConsoleButton />
          <!-- Login Button -->
          <LayoutHeaderLoginButton />
          <!-- Account Button -->
          <LayoutHeaderAccount />
        </div>

        <!-- ** Tablet ** -->
        <div v-if="isTablet" class="flex items-center gap-2">
          <!-- Search Button -->
          <LayoutHeaderSearchButton v-show="!isMenuOpen" />
          <!-- Login Button -->
          <LayoutHeaderLoginButton v-show="!isMenuOpen" />
          <!-- Account Button -->
          <LayoutHeaderAccount v-show="!isMenuOpen" />
          <!-- Menu Button -->
          <LayoutHeaderMenuButton />
        </div>

        <!-- ** Mobile ** -->
        <div v-if="isMobile" class="flex items-center">
          <!-- Search Button -->
          <LayoutHeaderSearchButton v-show="!isMenuOpen" />
          <!-- Login Button -->
          <LayoutHeaderLoginButton v-show="!isMenuOpen" />
          <!-- Account Button -->
          <LayoutHeaderAccount v-show="!isMenuOpen" />
          <!-- Menu Button -->
          <LayoutHeaderMenuButton />
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
  const menuStore = useMenuStore();
  const { isMenuOpen } = storeToRefs(menuStore);
  const { isDesktop, isTablet, isMobile } = useScreen();

  const headerClass = computed((): string => {
    if (!isMenuOpen.value) {
      return 'shadow-header';
    }
    if (!isMobile.value) {
      return 'border-b border-solid border-gray-400';
    }
    return '';
  });
</script>

<style lang="scss" scoped>
  .header-height {
    @apply h-header-mobile-height tablet:h-header-height;
  }
</style>
